/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/dispatch`, controller.plan, makeLayout, render);
    router(`/dashboard/dispatch/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/dispatch/subscribe`, controller.newPlan, makeLayout, render);
};
